import http from '../http'
import type {
  MyMedalDetailParams,
  MyMedalDetailResponse,
  MyMedalListResponse,
  MyMedalPopupResponse,
  MyMedalSummaryResponse,
  MyMedalWearParams,
  MyMedalWearResponse
} from '../Models/MyMedal'

export const getMyMedalList = (): Promise<MyMedalListResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/medal-student/list',
    method: 'get',
    loadingShow: '0'
  })
}

export const getMyMedalDetail = (params: MyMedalDetailParams): Promise<MyMedalDetailResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/medal-student/medalDetail',
    method: 'get',
    params,
    loadingShow: '0',
    toastShow: '0'
  })
}

export const postMyMedalWear = (data: MyMedalWearParams): Promise<MyMedalWearResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/medal-student/wearImage',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

export const getMyMedalPopupDetail = (): Promise<MyMedalPopupResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/medal-student/getPopups',
    method: 'get',
    loadingShow: '0',
    toastShow: '0'
  })
}

export const getMyMedalSummary = (): Promise<MyMedalSummaryResponse> => {
  return http.request({
    url: '/sands-lms/api/v1/medal-student/myMedal',
    method: 'get',
    loadingShow: '0',
    toastShow: '0'
  })
}
